import { GraphHoverCardContent } from "./content";
import { GraphHoverCardRoot } from "./root";
import { GraphHoverCardTrigger } from "./trigger";

export const GraphHoverCard = {
  Root: GraphHoverCardRoot,
  Trigger: GraphHoverCardTrigger,
  Content: GraphHoverCardContent,
};
